import classnames from 'classnames';
import s from './index.module.scss';

export const Toggle = ({ name, checked, disabled, className, onChange }) => {
  return (
    <label className={classnames(s.switch, className)}>
      <input
        type="checkbox"
        className={s.input}
        name={name}
        disabled={disabled}
        checked={checked}
        onChange={onChange}
      />
      <span className={s.slider} />
    </label>
  );
};
